import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {OccEndpointsService, Product} from '@spartacus/core';
import {Observable} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {ProductCodes} from '../models/product-codes.model';
import token from '../token/tokens';
const {PRODUCT_SEARCH_FIELDS_CONFIG, VARIANT_PRODUCT_SEARCH_FIELDS_CONFIG} = token.values;

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    @Inject(VARIANT_PRODUCT_SEARCH_FIELDS_CONFIG)
    protected variantProductSearchFields: string,
    @Inject(PRODUCT_SEARCH_FIELDS_CONFIG) protected productSearchFields: string,
  ) {}

  /**
   * Get display product id by material(supplierAlternativeAID)
   *
   * @param supplierAlternativeAID - material(supplierAlternativeAID) id
   */
  public getProductCodesBySupplierAlternativeAid(supplierAlternativeAID: string): Observable<ProductCodes> {
    const url: string = this.occEndpointsService.buildUrl('/products/details/material/' + supplierAlternativeAID);
    return this.http.get<ProductCodes>(url);
  }

  /**
   * Search for product
   *
   * @param productCode - code of the product
   * @param fields - this is the list of fields that should be returned in the response body. Examples: BASIC, DEFAULT, FULL
   */
  public searchForProduct(productCode: string, fields?: string): Observable<Product> {
    const apiUrl: string = this.occEndpointsService.buildUrl('/products/' + productCode);
    if (fields) {
      const params: HttpParams = new HttpParams().set('fields', fields);
      return this.http.get<any>(apiUrl, {params});
    } else {
      return this.http.get<any>(apiUrl);
    }
  }

  /**
   * Gets a product by its supplierAlternativeAID from the backend.
   *
   * @param supplierAlternativeId of the product
   */
  fetchProductBySupplierAlternativeId(supplierAlternativeId: string): Observable<Product> {
    return this.getProductCodesBySupplierAlternativeAid(supplierAlternativeId).pipe(
      mergeMap((codes) => this.searchForProduct(codes.code, this.variantProductSearchFields)),
    );
  }

  /**
   * Gets Display Product by its supplierAlternativeAID from the backend.
   *
   * @param supplierAlternativeId
   */
  fetchDisplayProductBySupplierAlternativeId(supplierAlternativeId: string): Observable<Product> {
    return this.getProductCodesBySupplierAlternativeAid(supplierAlternativeId).pipe(
      mergeMap((codes) => this.searchForProduct(codes.code, this.productSearchFields)),
    );
  }
}
